import { SECTION_CHILD_PATHS, SIDEBAR_SECTIONS } from '@/features/navigation/sidebar/sidebar.config';
import { isPathAllowed } from '@/lib/parseEnvList';
import { canAccessRoute } from './routeAccess';

type Perms = { canAny: (keys: readonly string[]) => boolean };

export function getFirstAccessibleChild(sectionPath: string, perms: Perms) {
  const children = SECTION_CHILD_PATHS[sectionPath] ?? [];

  return children.find((path) => isPathAllowed(path) && canAccessRoute(path, perms));
}

export function getFirstAccessibleRoute(perms: Perms) {
  for (const section of SIDEBAR_SECTIONS) {
    const child = getFirstAccessibleChild(section.to, perms);
    if (child) return child;
  }

  return undefined;
}
